import { OrganizationUnitType } from "../../../../mappers/organization.mapper";
import { OrganizationalUnitResponseDTO } from "../../../../open-api";

export const isCustomer = (
  organization: OrganizationalUnitResponseDTO | Pick<OrganizationalUnitResponseDTO, "grossType" | "type">
) => organization.type === OrganizationUnitType.CUSTOMER || organization.type === OrganizationUnitType.RESELLER;

export const isRoot = (organization: OrganizationalUnitResponseDTO) =>
  organization.unitType === OrganizationUnitType.ROOT;
